document.addEventListener("turbolinks: load", function() {
  alert('test')
  var options = {
    data: ["John", "Paul", "George", "Ringo"]
  };
  $('*[data-behavior="autocomplete"]').easyAutocomplete(options);
});
